import React, { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { Image as ImageIcon, Trash2, Upload } from 'lucide-react';
import { adminEnquetesAPI } from '../../utils/adminEnquetesAPI';
import { sucessoComHorario } from '../../utils/toastComHorario';

const API_ORIGIN = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1').replace(/\/api\/v1$/, '');

const UploadImagemPergunta = ({ enqueteId, pergunta, onChange }) => {
  const inputRef = useRef(null);
  const [enviando, setEnviando] = useState(false);

  const selecionarArquivo = () => inputRef.current?.click();

  const onArquivoSelecionado = async (e) => {
    const arquivo = e.target.files?.[0];
    if (!arquivo) return;

    setEnviando(true);
    try {
      await adminEnquetesAPI.enviarImagem(enqueteId, pergunta.id, arquivo);
      sucessoComHorario('Imagem enviada');
      onChange();
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao enviar imagem');
    } finally {
      setEnviando(false);
      e.target.value = '';
    }
  };

  const remover = async () => {
    try {
      await adminEnquetesAPI.removerImagem(enqueteId, pergunta.id);
      onChange();
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao remover imagem');
    }
  };

  return (
    <div className="mt-3">
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        onChange={onArquivoSelecionado}
      />

      {pergunta.imagem_path ? (
        <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-xl p-2.5">
          <img
            src={`${API_ORIGIN}${pergunta.imagem_path}`}
            alt="Ilustração da pergunta"
            className="h-14 w-14 object-cover rounded-lg border border-gray-200 flex-shrink-0"
          />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-gray-700">Imagem anexada</p>
            <p className="text-xs text-gray-400">Aparece junto da pergunta no formulário público</p>
          </div>
          <button
            onClick={remover}
            className="flex-shrink-0 flex items-center gap-1.5 text-xs font-medium text-red-500 hover:bg-red-50 rounded-lg px-2.5 py-1.5 transition-colors"
          >
            <Trash2 className="w-3.5 h-3.5" /> Remover
          </button>
        </div>
      ) : (
        <button
          onClick={selecionarArquivo}
          disabled={enviando}
          className="w-full flex items-center justify-center gap-2 text-sm text-gray-500 hover:text-primary-600 border border-dashed border-gray-300 hover:border-primary-300 hover:bg-primary-50/40 rounded-xl py-3 transition-colors disabled:opacity-60"
        >
          {enviando ? (
            <>
              <div className="loading-spinner w-4 h-4" /> Enviando...
            </>
          ) : (
            <>
              <Upload className="w-4 h-4" /> Adicionar imagem à pergunta
              <ImageIcon className="w-4 h-4 text-gray-300" />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default UploadImagemPergunta;
